import { Log, now } from ".././MyHelpers";
import * as PIXI from 'pixi.js'
import { Settings } from "../Settings";
export class ShakeAnimationKeyframe
{
	public x: number;
	public y: number;
	public rotation: number;

	public cssTransform: string;

	public constructor(x: number, y: number, rotation: number) {
		this.x = x;
		this.y = y;
		this.rotation = rotation;

		this.cssTransform = "rotate(" + this.rotation + "deg) translate(" + this.x + "px, " + this.y + "px)";
	}
}


export class ShakeAnimation
{
	private shakeContainer: HTMLElement = null;
	private running: boolean = false;
	private stopOnNextUpdate: boolean = false;

	private idleKeyframe = new ShakeAnimationKeyframe(0, 0, 0);

    private keyframes: ShakeAnimationKeyframe[] = [
        new ShakeAnimationKeyframe(1, 1, 0),
		new ShakeAnimationKeyframe(-1, -2, -1),
		new ShakeAnimationKeyframe(-3, 0, 1),
		new ShakeAnimationKeyframe(3, 2, 0),
		new ShakeAnimationKeyframe(1, -1, 1),
		new ShakeAnimationKeyframe(-1, 2, -1),
		new ShakeAnimationKeyframe(-3, 1, 0),
		new ShakeAnimationKeyframe(3, 1, -1),
		new ShakeAnimationKeyframe(-1, -1, 1),
		new ShakeAnimationKeyframe(1, 2, 0),
		new ShakeAnimationKeyframe(0, 0, 0)
    ];


    private started: number = 0; // time, when animation started
    private frameDuration: number = 1000 / 30;
    private frameIndex: number = 0;

    private logGroup: string = "ShakeAnimation";
	private containerReelsPIXI? : PIXI.Container<PIXI.DisplayObject> = null;

	public constructor(shakeConteainer: HTMLElement ) {
		this.shakeContainer = shakeConteainer;	
		if (Settings.Enable2plus1)
		{
			this.ScrenNumberConfiguration = 2;
		}	
	}

	public CreateShakeAnimationPixi(containerReelsPIXI? : PIXI.Container<PIXI.DisplayObject>){
		this.containerReelsPIXI = containerReelsPIXI;
	}

	public Start() {
		// Log.Debug(this.logGroup, "Started")
		this.running = true;
		this.started = now();
		this.frameIndex = 0;
	}

	public Stop() {
		// Log.Debug(this.logGroup, "Stopped")
		//this.running = false;
		this.stopOnNextUpdate = true;
	}
	protected ScrenNumberConfiguration: number = Settings.Screens;
	public Update() {
		if (this.running) {

			let animDuration = now() - this.started;
			let newFrameIndex = Math.floor(animDuration / this.frameDuration) % this.keyframes.length;
			let frame: ShakeAnimationKeyframe = this.keyframes[newFrameIndex];

			// reset to default position when animation is stopped
			if (this.stopOnNextUpdate) {
				frame = this.idleKeyframe;
				this.shakeContainer.style.transform = frame.cssTransform;
				if (this.containerReelsPIXI != null) {
					//this.containerReelsPIXI.rotation = Math.PI/frame.rotation;	
					if (this.containerReelsPIXI?.transform.position != null) {
						this.containerReelsPIXI.transform.position.x = frame.x + this.containerReelsPIXI.transform.position.x;
						this.containerReelsPIXI.transform.position.y = frame.y ;
					}
				}

				this.running = false;
				this.stopOnNextUpdate = false;
			}
			else if (newFrameIndex != this.frameIndex) {
				//// Log.Debug(this.logGroup, "New frame: " + this.frameIndex);
				this.frameIndex = newFrameIndex;
				this.shakeContainer.style.transform = frame.cssTransform;
				if (this.containerReelsPIXI != null) {
					//this.containerReelsPIXI.rotation = Math.PI/frame.rotation;
					if (this.containerReelsPIXI?.transform?.position != null) {
						this.containerReelsPIXI.transform.position.x = frame.x + this.containerReelsPIXI.transform.position.x;
						this.containerReelsPIXI.transform.position.y = frame.y ;
					}
				}
			}
		}
	}
}